import ExternalAlbumUploadView from './ExternalAlbumUploadView';

export default ExternalAlbumUploadView;
